
import { api } from './api';

export const streamApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStream: build.query({
      query: (id) => ({
        url: `stream/${id}`,
      }),
      providesTags: (result, _err, id) => [
        { type: 'Streams', id: result?.data?.model?.ID || id },
      ],
    }),
    updateStream: build.mutation({
      query: ({id, form}) => ({
        url: `stream/${id}`,
        method: 'PUT',
        body: JSON.stringify(form),
      }),
      invalidatesTags: (result, error, {id}) =>
        error ? [] : [{ type: 'Streams', id: result?.id || id }],
    }),
    deleteStream: build.mutation({
      query: (id) => ({
        url: `stream/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Streams', id: 'LIST' }],
    }),
    createStream: build.mutation({
      query: ({form}) => ({
        url: 'stream',
        method: 'POST',
        body: JSON.stringify(form),
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Streams', id: 'LIST' }],
    }),
    pasteElements: build.mutation({
      query: ({streams, elements}) => ({
        url: 'streams/paste_elements',
        method: 'POST',
        body: JSON.stringify({streams, elements}),
      }),
      invalidatesTags: (result, error) =>
        error || !result?.id ? [] : [{ type: 'Streams', id: result.id }],
    })
  }),
})

export const prepare_form = (pre_form) => {
  let form = pre_form;
  let pos = 1;
  form.items = form.items.map((f) => {
    let edited_f = { ...f };
    if (
      edited_f.model &&
      typeof edited_f.model.ID === 'string' &&
      edited_f.model.ID.includes('new_')
    ) {
      edited_f.model = null;
    }

    if (edited_f.element_type === "stream") {
      edited_f.stream_element = edited_f.element;
      edited_f.element = null;
    }

    edited_f.position = pos;
    pos += 1;
    return edited_f;
  });
  return form;
}

export const validate_form = (form) => {
  let errors = [];

  if (!form.items || form.items.length < 1) {
    errors.push('Es wird mindestens 1 Elemente benötigt.');
  }

  let current_orientation = form.orientation;

  if (
    form.items.find((i) => {
      if (i.element_type === 'stream') {
        return i.stream_element.orientation === 2
          ? false
          : i.stream_element.orientation !== current_orientation;
      }
      // Variant-group items get resolved server-side per variant + device
      // orientation, so the editor doesn't enforce the orientation match
      // here — let the player resolver pick the matching slot at runtime.
      if (i.variant_group_id) return false;
      if (!i.element) return false;
      return i.element.orientation === 2
        ? false
        : i.element.orientation !== current_orientation;
    })
  ) {
    errors.push(
      'Die eingestellte Orientierung steht im Konflikt mit einem Element im Stream!'
    );
  }

  if (!form.name || form.name.length < 2) {
    errors.push('Es muss ein Name angegeben werden');
  }

  return errors.length < 1 ? null : errors.join(' und ');
}

export const {
  useGetStreamQuery,
  useLazyGetStreamQuery,
  useCreateStreamMutation,
  useUpdateStreamMutation,
  useDeleteStreamMutation,
  usePasteElementsMutation,
} = streamApi;
